export default {
	methods: {
		openTagDialog(list, item){
			this.tagsModalOn = true
			this.tagInQuestion = {list, item}
		}
	}
}